import makeStyles from '@mui/styles/makeStyles'
import cc from 'classcat'
import React from 'react'
// @ts-ignore - Vite SVG import
import MealsSvg from '../../assets/Image/meals.svg?react'

const useStyles = makeStyles((theme: any) => ({
  mealIcon: { width: 200 },
  oneMeal: {
    '& [class$=meal-main]': {
      stroke: theme.palette.primary.main,
    },
  },
  allMeals: {
    '& [class$=meal-main]': {
      stroke: theme.palette.primary.main,
    },
    '& [class$=meal-side]': {
      stroke: theme.palette.primary.main,
    },
  },
}))

const MealIcon = ({ value = 'false' }: { value?: string }) => {
  const classes = useStyles()
  return (
    <MealsSvg
      width={200}
      height={120}
      className={cc([
        classes.mealIcon,
        value === 'true' && classes.oneMeal,
        value === 'false' && classes.allMeals,
      ])}
    />
  )
}

export default MealIcon
